import { formatDuration, type Plan } from "@roxpacer/core";
import { useEstimate } from "../lib/use-estimate";

const DOT: Record<string, string> = {
  run: "bg-run",
  roxzone: "bg-roxzone",
  station: "bg-station",
  handover: "bg-handover",
};

export function SplitTable({ plan }: { plan: Plan }) {
  const estimate = useEstimate(plan);
  const showAthlete = plan.format === "relay";
  const names = new Map(plan.athletes.map((a) => [a.id, a.name]));

  return (
    <details className="card group p-4" open>
      <summary className="label cursor-pointer list-none select-none">
        <span className="inline-block transition-transform group-open:rotate-90">›</span> Splits
      </summary>
      <table className="mt-2 w-full text-sm">
        <thead>
          <tr className="text-left text-xs text-muted">
            <th className="py-1 font-normal">Segment</th>
            {showAthlete && <th className="pl-2 font-normal">Athlete</th>}
            <th className="pl-3 text-right font-normal">Target</th>
            <th className="pl-3 text-right font-normal">Elapsed</th>
          </tr>
        </thead>
        <tbody>
          {estimate.segments.map((segment) => (
            <tr
              key={segment.id}
              className={`border-t border-line ${segment.type === "station" ? "font-medium" : "text-ink-2"}`}
            >
              <td className="py-1">
                <span className="flex items-center gap-2">
                  <span aria-hidden className={`size-2 rounded-full ${DOT[segment.type]}`} />
                  {segment.label}
                </span>
              </td>
              {showAthlete && (
                <td className="max-w-24 truncate pl-2">
                  {segment.type === "handover"
                    ? `→ ${names.get(segment.athleteIds.at(-1)!)}`
                    : names.get(segment.athleteIds[0]!)}
                </td>
              )}
              <td className="pl-3 text-right tabular-nums">{formatDuration(segment.targetSec)}</td>
              <td className="pl-3 text-right tabular-nums text-ink">
                {formatDuration(segment.endSec)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </details>
  );
}
